import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import ErrorPage from "./components/ErrorPage/ErrorPage";
import Footer from "./components/Footer/Footer";

const App = () => {

    return (
        <div id="outer-container">
            <Router>
                <Sidebar />
                <div id="page-wrap">
                    <h1>React Burger Menu package</h1>
                </div>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/about" component={About}/>
                    <Route path="/contact" component={Contact}/>
                    <Route component={ErrorPage} />
                </Switch>
                <Footer />
            </Router>
        </div>
    );
};

export default App;